import { request }  from '@/request'
import doughnut from '@/components/common/DoughnutChart.js'
import colors from '@/utils/colors.js'
import { exportCSVFile } from '@/utils'
import { PublicHeader } from '../../../components/common'
import { entidadeBySigla } from '@/utils/entidades.js'

export default {
  name: 'PDG',
  components: {
    doughnut,
    PublicHeader
  },
  data() {
    return {
      metas: [],
      unidade: '',
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = ((value * 100) / sum).toFixed(2) + '%'
              return percentage
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      },
    }
  },
  created() {
    this.loadCompromissos()
  },
  computed: {
    total () {
      return this.metas.length
    },
    concluidas() {
      const concluidas = this.metas.filter(i => (i.tipostatusplano === 'CONCLUÍDA'))
      return concluidas.length
    },
    emAndamento() {
      const emAndamento = this.metas.filter(i => (i.tipostatusplano === 'EM ANDAMENTO'))
      return emAndamento.length
    },
    naoCumpridas() {
      const naoCumpridas = this.metas.filter(i => (i.tipostatusplano === 'NÃO CUMPRIDA'))
      return naoCumpridas.length
    },
    metasPorStatus() {
      const status = [ ... new Set(this.metas.map(m => (m.tipostatusplano))) ]
      const result = status.map(status => ({ status, total: this.metas.filter(m => m.tipostatusplano === status).length }))

      return result
    },
    metasSecretariaStatus() {
      if (unidade) return []

      const { metas, unidade } = this
      const metasSecretaria = metas.filter(m => (m.unidaderesponsavel === unidade))

      const status = [ ... new Set(metasSecretaria.map(m => (m.tipostatusplano))) ]
      const result = status.map(status => ({ status, total: metasSecretaria.filter(m => m.tipostatusplano === status).length }))

      return result
    },
    secretarias() {
      const data = [ ... new Set(this.metas.map(m => (m.unidaderesponsavel))) ]
      data.sort()

      this.unidade = data[0]

      return data
    },
    secretariaSumario() {
      const data = {
        total: 0,
        totalPorcentagem: 0,
        concluidas: 0,
        emAndamento: 0,
        naoCumpridas: 0,
        naoIniciadas: 0
      }

      if (!this.unidade) return { ...data }

      const metasSecretaria = this.metas.filter(m => (m.unidaderesponsavel === this.unidade))

      data.total = metasSecretaria.length
      data.totalPorcentagem = ((data.total / this.metas.length) * 100).toFixed(2)
      data.concluidas = metasSecretaria.filter(i => (i.tipostatusplano === 'CONCLUÍDA')).length
      data.emAndamento = metasSecretaria.filter(i => (i.tipostatusplano === 'EM ANDAMENTO')).length
      data.naoCumpridas = metasSecretaria.filter(i => (i.tipostatusplano === 'NÃO CUMPRIDA')).length
      data.naoIniciadas = metasSecretaria.filter(i => (i.tipostatusplano === 'NÃO INFORMADA')).length

      return { ...data }
    },
    secretariasTop6Metas() {
      const metasPorSecretaria = Object.groupBy(this.metas, ({ unidaderesponsavel }) => unidaderesponsavel)
      const ranking = []

      for(const sigla in metasPorSecretaria) {
        const { length: count } = metasPorSecretaria[sigla]
        const percentual = ((count / this.metas.length) * 100).toFixed(2)
        ranking.push({ sigla, count, percentual })
      }

      ranking.sort((a,b) => b.total - a.total)

      return ranking.slice(0, 6)
    },
    rankingConcluidas() {
      const { metas, entidadeBySigla } = this
      const metasAgrupdasSecretaria = Object.groupBy(metas, ({ unidaderesponsavel }) => unidaderesponsavel)
      const data = []
      let totalMetas = 0
      let totalConcluidas = 0

      for (const sigla in metasAgrupdasSecretaria) {
        const metasSecretaria = metasAgrupdasSecretaria[sigla]
        const metasSecretariaConcluidas = metasSecretaria.filter(m => (m.tipostatusplano === 'CONCLUÍDA'))

        const { length: total } = metasSecretaria
        const { length: concluidas } = metasSecretariaConcluidas
        const percentual = ((concluidas/total)* 100).toFixed(2)

        data.push({ sigla, secretaria: entidadeBySigla(sigla), total, concluidas, percentual })

        totalMetas += total
        totalConcluidas += concluidas
      }

      data.sort((a, b) => b.percentual - a.percentual)

      return {
        data,
        totalMetas,
        totalConcluidas,
        totalPercentual: ((totalConcluidas / totalMetas) * 100).toFixed(2)
      }
    },
    link_externo() {
      return (
        'https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/montarMapaPlanoMunicipalGoverno/' +
        this.unidade.iduorre
      )
    }
  },
  methods: {
    async loadCompromissos() {
      const { status, data } = await request.get('sigsantos/planogoverno')

      if (status != 200) return this.$toastr.e('Houve um problema ao tentar carregar os compromissos, tente novamente daqui alguns minutos!')

      this.metas = data
    },
    createChartData(dados) {
      return {
        labels: [ ...dados.map(({ status }) => (status)) ],
        datasets: [
          {
            data: [ ...dados.map(({ total }) => (total)) ],
            backgroundColor: colors.coresRGB,
            borderWidth: 0
          }
        ]
      }
    },
    DownloadJSON2CSV() {
      const headers = {
        indice: ' - ',
        sigla: 'Sigla',
        secretaria: 'Unidade',
        total: 'Total de Metas',
        concluidas: 'Concluídas',
        percentual: 'Percentual (%)'
      }

      const { data, totalMetas: total, totalConcluidas: concluidas, totalPercentual: percentual } = this.rankingConcluidas
      const footers = { indice: '', sigla: '', secretaria: 'TOTAL', total, concluidas, percentual: percentual.replace('.', ',') }

      const items = [ ...data.map(({ sigla, secretaria, total, concluidas, percentual }, index) => ({
          indice: (index + 1),
          sigla,
          secretaria,
          total,
          concluidas,
          percentual: percentual.replace('.', ','),
      })) ]

      exportCSVFile(headers, [ ...items, ...footers ], 'ranking_conclusao')
    },
    entidadeBySigla
  },
}



// WEBPACK FOOTER //
// ./src/views/public/pdg/app.js